import React from 'react';

export type Props = {
  className?: string;
  fill?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};
export const Star = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      className={props.className}
      onClick={props.onClick}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fill={props.fill || 'white'}
        d={`M11.0456 3.05123C11.3382 2.11593 12.6618 2.11593 12.9544 3.05123L14.4019 
          7.67895C14.5337 8.10018 14.926 8.38522 15.3673 8.38036L20.2159 8.32699C21.1958 
          8.3162 21.6048 9.57511 20.8057 10.1424L16.8518 12.9491C16.4919 13.2046 16.342 13.6658 
          16.483 14.084L18.0321 18.6787C18.3452 19.6074 17.2743 20.3854 16.4878 19.8007L12.5967 
          16.9076C12.2425 16.6443 11.7575 16.6443 11.4033 16.9076L7.51217 19.8007C6.72574 20.3854 
          5.65485 19.6074 5.96792 18.6787L7.51696 14.084C7.65796 13.6658 7.5081 13.2046 7.14821 
          12.9491L3.19429 10.1424C2.39517 9.57511 2.80422 8.3162 3.78414 8.32699L8.63267 
          8.38036C9.074 8.38522 9.46632 8.10018 9.59808 7.67895L11.0456 3.05123Z`}
      />
    </svg>
  );
});

Star.displayName = 'Star';
